import VideoBuses from "../../../Assets/videos/buses.mp4";
import VideoCta from "../../../Assets/videos/cta.mp4";
import VideoFavorites from "../../../Assets/videos/favorites.mp4";
import VideoMetra from "../../../Assets/videos/metra.mp4";
import { ScreenRecording } from "./ScreenRecording";
import { accessibilityLabels } from "./accessibilityLabels";
import { FeatureSection } from "./FeatureSection";

/**
 * Section highlighting all the features of the app.
 */
export function AllFeaturesSection() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingLeft: 10,
        paddingRight: 10,
        marginTop: 10,
        gap: 50,
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box", // Hacky fix to prevent horizontal scrolling
        overflow: "hidden",
      }}
    >
      <FeatureSection
        title="Track ‘L’ and Metra trains"
        description="View live locations and departure times for CTA (‘L’) and Metra trains."
      >
        {/* Show both videos side by side, shrinking if needed to fit */}
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <ScreenRecording
            src={VideoCta}
            ariaLabel={accessibilityLabels.ctaTrainsVideo}
            // Shrink video to fit if needed
            style={{ flexShrink: 1, minWidth: 0 }}
          />

          <ScreenRecording
            src={VideoMetra}
            ariaLabel={accessibilityLabels.metraTrainsVideo}
            // Shrink video to fit if needed
            style={{ flexShrink: 1, minWidth: 0 }}
          />
        </div>
      </FeatureSection>

      <FeatureSection
        title="Track buses"
        description="View live locations and departure times for CTA buses."
      >
        <ScreenRecording
          src={VideoBuses}
          ariaLabel={accessibilityLabels.busesVideo}
        />
      </FeatureSection>

      <FeatureSection
        title="Save your favorite stops"
        description="Access your saved stops with a single tap."
      >
        <ScreenRecording
          src={VideoFavorites}
          ariaLabel={accessibilityLabels.favoritesVideo}
        />
      </FeatureSection>
    </div>
  );
}
